import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid } from 'react-bootstrap';
import i18n from 'kodyl-js/i18n/react';
import List from './list';
import CityNav from './top-nav';

@connect(({ cities }) => ({ cities }))
@i18n
class Cities extends Component {
  render() {
    const { cities } = this.props;
    return (
      <div>
        <CityNav hideOthersLink />
        <Grid>
          <h1>{this.i18n('Where do you want to live?')}</h1>
          <List cities={cities.list} />
        </Grid>
      </div>
    );
  }
}

export default Cities;
